import { motion } from 'framer-motion';

const footerLinks = {
  servicos: [
    { name: 'Corte Masculino', href: '#servicos' },
    { name: 'Barba Completa', href: '#servicos' },
    { name: 'Corte + Barba', href: '#servicos' },
    { name: 'Pigmentação', href: '#servicos' },
  ],
  paginas: [
    { name: 'Início', href: '#hero' },
    { name: 'Sobre', href: '#sobre' },
    { name: 'Galeria', href: '#galeria' },
    { name: 'Equipe', href: '#equipe' },
  ],
};

export default function Footer() {
  return (
    <footer className="relative bg-dark-950 border-t border-white/5 pt-20 md:pt-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-premium-400 to-premium-600 flex items-center justify-center">
                <i className="ri-scissors-cut-line text-white text-lg"></i>
              </div>
              <div>
                <span className="font-heading text-lg font-bold text-white tracking-wide block leading-tight">
                  Tal Pai, Tal Filho
                </span>
                <span className="text-[10px] text-premium-400 tracking-[0.2em] uppercase">
                  Barbearia
                </span>
              </div>
            </div>
            <p className="text-white/40 text-sm leading-relaxed mb-6">
              Tradição masculina, elegância e excelência. Um espaço criado exclusivamente para homens que valorizam estilo e sofisticação.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com/talpaitalfilho"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-md bg-white/5 hover:bg-premium-600/30 flex items-center justify-center transition-colors duration-300"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-white/60 hover:text-white transition-colors"></i>
              </a>
              <a
                href="https://wa.me/5585999999999"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-md bg-white/5 hover:bg-green-700/30 flex items-center justify-center transition-colors duration-300"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-white/60 hover:text-white transition-colors"></i>
              </a>
              <a
                href="https://maps.google.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-md bg-white/5 hover:bg-premium-600/30 flex items-center justify-center transition-colors duration-300"
                aria-label="Google Maps"
              >
                <i className="ri-map-pin-2-line text-white/60 hover:text-white transition-colors"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white text-sm font-semibold tracking-wide mb-5">Serviços</h3>
            <ul className="space-y-3">
              {footerLinks.servicos.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-white/40 hover:text-premium-400 text-sm transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white text-sm font-semibold tracking-wide mb-5">Páginas</h3>
            <ul className="space-y-3">
              {footerLinks.paginas.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-white/40 hover:text-premium-400 text-sm transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white text-sm font-semibold tracking-wide mb-5">Contato</h3>
            <div className="space-y-3 text-sm">
              <p className="text-white/40">
                <i className="ri-map-pin-line text-premium-400 mr-2"></i>
                Av. Senador Virgílio Távora, 800<br />
                <span className="ml-5">Aldeota, Fortaleza - CE</span>
              </p>
              <p className="text-white/40">
                <i className="ri-phone-line text-premium-400 mr-2"></i>
                (85) 99999-9999
              </p>
              <p className="text-white/40">
                <i className="ri-time-line text-premium-400 mr-2"></i>
                Seg - Sex: 9h às 20h<br />
                <span className="ml-5">Sáb: 8h às 18h</span>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-14 md:mt-16 pt-8 pb-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} Tal Pai, Tal Filho Barbearia. Todos os direitos reservados.
          </p>
          <p className="text-white/20 text-xs">
            Feito com <span className="text-premium-500">excelência</span> em Fortaleza-CE
          </p>
        </div>
      </div>
    </footer>
  );
}